
import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Input, Row, Col, Select, Spin, message, List } from 'antd';
import Info from './info';

const Component = (props:any) => {
  const {status,setStatus,curInfo}=props;

  const closeModal=()=>{
    setStatus(false);
  }

  return (
    <Modal
      title={<div 
      className="t2"
            style={{
              borderBottom: '1px solid #eee',
              paddingBottom: '1rem',
              paddingLeft: '1rem'
            }}
      
      >{curInfo.cname}原子信息 {curInfo.symbol}（{curInfo.name}）：</div>}
      open={status}
      onOk={closeModal}
      onCancel={closeModal}
      
      width={800}
      // footer={null}
      footer={<Button onClick={closeModal}>关闭</Button>}
    >
      < Info curInfo={curInfo}/>

    </Modal>
  );
};


export default Component;

